const SecureSchemaRequest = process.env.VUE_APP_VUE_APP_SECURE_SCHEMA_REQUEST;

export const formatUrl = (url) => {
  if (SecureSchemaRequest) return url.replace("http", "https");

  return url;
}